module.exports = __webpack_public_path__ + "static/media/organization.c6ae4125.svg";